import maxios from '@/utils/axios/maxios'

// 신고 API
const bugReportApi = {
  // 문제 신고하기
  postErrorReportCustomProblem: (data: req.BugReportData) => {
    return maxios.post(`/bug-report/content/problem`, data)
  },
  // 시중문제 신고하기
  postErrorReportPublicProblem: (data: req.BugReportData) => {
    return maxios.post(`/bug-report/content/public-problem`, data)
  },
  // 유형 신고하기
  postErrorReportConcept: (data: req.BugReportData) => {
    return maxios.post(`/bug-report/content/concept`, data)
  },
  postErrorReportLittleChapter: (data: req.BugReportData) => {
    return maxios.post(`/bug-report/content/little-chapter`, data)
  },

  // 학습지 신고하기
  postErrorReportWorksheet: (data: req.BugReportData) => {
    return maxios.post(`/bug-report/content/worksheet`, data)
  },
}

export default bugReportApi
